import { NavBar } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { AppSubNav } from "@src/components/widgets/AppSubNav/AppSubNav";
import { useRequestsForInvoicingNavigation } from "@src/components/widgets/AppSubNav/navigation-invoices/requests-for-invoicing/hooks";
import { useScreenType } from "@src/utils/hooks/useIsMobile";
import { observer } from "mobx-react-lite";

type Props = {
  invoiceId?: string;
};
export const RequestForInvoicingNavigation = observer(
  function RequestForInvoicingNavigation({ invoiceId }: Props) {
    const { visiblePages, activeSubpage, data, activePage } =
      useRequestsForInvoicingNavigation(invoiceId);
    const { isDesktop } = useScreenType();

    return (
      <AppSubNav>
        {visiblePages.map((page) => (
          <NavBar.Item
            key={page.href.pathname}
            href={page.href}
            active={false}
            badgeColorScheme="green"
            badgeContent={
              activePage?.href.pathname === "/invoices/for-invoicing"
                ? data
                : undefined
            }
          >
            {page.title()}
          </NavBar.Item>
        ))}

        {isDesktop && activeSubpage && <Icon name="chevron-right" />}

        {activeSubpage && (
          <NavBar.Item href={activeSubpage.href} active={false}>
            {activeSubpage.title()}
          </NavBar.Item>
        )}
      </AppSubNav>
    );
  },
);
